<template>
  <div>
    <div class="section has-background">
      <b-container>
        <div class="section-counter">
          <b-row cols="1" cols-sm="1" cols-md="2" cols-lg="4">
            <b-col>
              <BeerBottlesSvg />
              <h3>500</h3>
              <p>de sticle de bere pe zi</p>
            </b-col>
            <b-col>
              <BeerProcessSvg />
              <h3>100%</h3>
              <p>retețe originale</p>
            </b-col>
            <b-col>
              <BeerIngredientsSvg />
              <h3>150</h3>
              <p>de parteneri de încredere</p>
            </b-col>
            <b-col>
              <BeerQualitySvg />
              <h3>{{userVal}}</h3>
              <p>de clienți fericiți</p>
            </b-col>
          </b-row>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import BeerBottlesSvg from "./BeerBottlesSvg";
import BeerIngredientsSvg from "./BeerIngredientsSvg";
import BeerProcessSvg from "./BeerProcessSvg";
import BeerQualitySvg from "./BeerQualitySvg";

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

var moment = require("moment"); // require
moment().format();
import numeral from "numeral";

export default {
  name: "Counter",

  data() {
    return {
      startVal: 233
    };
  },

  methods: {
    increment: function() {
      this.startVal += 1;
      setTimeout(this.increment, getRandomInt(200, 1200));
    }
  },

  mounted: function() {
    const now = moment();
    const startDay = moment("2019-01-01");
    const daysFrom = now.diff(startDay, "days");
    const secondsToday = now.diff(moment().startOf("day"), "seconds");
    const customersPerDay = 200;
    this.startVal = Math.floor(daysFrom * customersPerDay) + secondsToday;
    setTimeout(this.increment, getRandomInt(200, 1200));
  },

  computed: {
    userVal() {
      return numeral(this.startVal).format("0,0");
    }
  },

  components: {
    BeerBottlesSvg,
    BeerIngredientsSvg,
    BeerProcessSvg,
    BeerQualitySvg
  }
};
</script>

<style>
.has-background {
  background-color: #efefef;
}

.section-counter svg {
  width: 75px;
  height: 75px;
  fill: #8b4e2e;
  margin-bottom: 15px;
}

.beer-icon {
  width: 100px;
}

.section-counter {
  padding-top: 50px;
  padding-bottom: 50px;
}

.section-counter span {
  font-size: 42px;
  font-weight: 600;
}

.section-counter h3 {
  font-size: 42px;
  font-weight: 600;
}

.section-counter p {
  font-size: 14px;
  text-transform: uppercase;
  color: #8b4e2e;
  font-weight: 600;
}

.middle {
  width: 100%;
}
</style>